import { getEkardoApolloClient, NETFRONT_PRODUCT_QUICKCODES } from '@netfront/common-library';
import {
  GET_CONTENT_PAGE_BY_URL_QUERY,
  IDBContentGroup,
  IDBContentPage,
  IGetContentPageByUrlQueryGraphQLResponse,
  IGetContentPageByUrlQueryVariables,
} from '@netfront/ekardo-content-library';
import { GetStaticPathsResult, GetStaticPropsContext, NextPage } from 'next';
import { ParsedUrlQuery } from 'querystring';

import { DocsContentPage } from '../../components/Pages';
import { PUBLISHED, STATIC_PAGE_REGENERATION_TIME_IN_SECONDS } from '../../constants';
import { getContentGroupByType } from '../../utils';

interface DocsContentNextPageProps {
  contentGroups: IDBContentGroup[];
  contentPage: IDBContentPage;
}

const DocsContentNextPage: NextPage<DocsContentNextPageProps> = ({ contentGroups, contentPage }) => {
  return <DocsContentPage contentGroups={contentGroups} contentPage={contentPage} />;
};

export async function getStaticPaths(): Promise<GetStaticPathsResult> {
  const searchContentGroups = await getContentGroupByType('HELP');

  const contentPages = searchContentGroups.flatMap((contentGroup) => contentGroup.contentPages);

  const paths = contentPages.map(({ url: pageUrl }) => ({
    params: {
      pageUrl,
    },
  }));

  return {
    paths,
    fallback: false,
  };
}

export async function getStaticProps(context: GetStaticPropsContext) {
  const contentGroups = await getContentGroupByType('HELP');

  const client = getEkardoApolloClient({
    product: NETFRONT_PRODUCT_QUICKCODES,
  });

  const { pageUrl } = context.params as ParsedUrlQuery;

  const {
    data: {
      contentPage: { getContentPageByUrl: contentPage },
    },
  } = await client.query<IGetContentPageByUrlQueryGraphQLResponse, IGetContentPageByUrlQueryVariables>({
    query: GET_CONTENT_PAGE_BY_URL_QUERY,
    variables: {
      contentPageUrl: String(pageUrl),
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      incrementStats: false,
      withAnswers: false,
    },
  });

  const sortedGroups = [...contentGroups].sort((a, b) => a.sort - b.sort).filter(({ status }) => status === PUBLISHED);

  return {
    props: {
      contentGroups: sortedGroups,
      contentPage,
    },
    revalidate: STATIC_PAGE_REGENERATION_TIME_IN_SECONDS,
  };
}

// eslint-disable-next-line import/no-default-export
export default DocsContentNextPage;
